import Template from "./template";
import paper from "paper";
import ComponentPort from "../core/componentPort";
import { LogicalLayerType, ValveType } from "../core/init";
import ValveTemplate from "./valveTemplate";

export default class Valve extends ValveTemplate {
    constructor(valveType: ValveType) {
        super(valveType);
    }

    __setupDefinitions(): void  {
        this.__unique = {
            position: "Point"
        };

        this.__heritable = {
            componentSpacing: "Float",
            rotation: "Float",
            length: "Float",
            width: "Float",
            depth: "Float",
            mirrorByX: "Float",
            mirrorByY: "Float"
        };

        this.__defaults = {
            componentSpacing: 2000,
            rotation: 0,
            width: 2000,
            length: 1000,
            depth: 250,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__units = {
            componentSpacing: "μm",
            rotation: "°",
            length: "μm",
            width: "μm",
            depth: "μm"
        };

        this.__minimum = {
            componentSpacing: 0,
            rotation: 0,
            width: 30,
            length: 120,
            depth: 10,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__maximum = {
            componentSpacing: 10000,
            rotation: 180,
            width: 6000,
            length: 24 * 1000,
            depth: 1200,
            mirrorByX: 1,
            mirrorByY: 1
        };

        this.__featureParams = {
            componentSpacing: "componentSpacing",
            position: "position",
            length: "length",
            width: "width",
            rotation: "rotation",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__targetParams = {
            componentSpacing: "componentSpacing",
            length: "length",
            width: "width",
            rotation: "rotation",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__placementTool = "valveInsertionTool";

        this.__toolParams = {
            position: "position"
        };

        this.__renderKeys = ["CONTROL"];

        this.__mint = "VALVE";

        this.__zOffsetKeys = {
            CONTROL: "depth"
        };

        this.__substrateOffset = {
            CONTROL: "+1"
        };
    }

    getPorts(params: { [k: string]: any }) {
        const l = params.length;
        const w = params.width;
        const ports = [];
        // Center-relative cardinals (1=top, 2=right, 3=bottom, 4=left).
        // Super_Mux MINT uses v17 4 / v25 3 as approach sides.
        ports.push(new ComponentPort(0, -l / 2, "1", LogicalLayerType.CONTROL));
        ports.push(new ComponentPort(w / 2, 0, "2", LogicalLayerType.CONTROL));
        ports.push(new ComponentPort(0, l / 2, "3", LogicalLayerType.CONTROL));
        ports.push(new ComponentPort(-w / 2, 0, "4", LogicalLayerType.CONTROL));
        return ports;
    }

    render2D(params: { [k: string]: any }, key = "CONTROL") {
        const position = params.position;
        const px = position[0];
        const py = position[1];
        const l = params.length;
        const w = params.width;
        const color = params.color;
        const rotation = params.rotation;
        const startX = px - w / 2;
        const startY = py - l / 2;
        const endX = px + w / 2;
        const endY = py + l / 2;
        const startPoint = new paper.Point(startX, startY);
        const endPoint = new paper.Point(endX, endY);
        const rec = new paper.Path.Rectangle({
            from: startPoint,
            to: endPoint,
            radius: 0,
            fillColor: color,
            strokeWidth: 0
        });
        let compoundPath = new paper.CompoundPath(rec);
        compoundPath.fillColor = color;
        this.transformRender(params,compoundPath);
        return (compoundPath);
    }

    render2DTarget(key: string | null, params: { [k: string]: any }) {
        const render = this.render2D(params, "CONTROL");
        render.fillColor = params.color;
        render.fillColor!.alpha = 0.5;
        return render;
    }
}
